import push from '../../utils/routing';
import { currentClassRoomId } from '../../../core/selectors/classroom';

export default () => (_dispatch, getState) =>
  push(`/dashboard/${currentClassRoomId(getState())}/community/scheduled`);
